import { useState } from "react"
import { Link } from "react-router-dom"
import { FaPencilAlt, FaTrashAlt, FaGripVertical } from 'react-icons/fa'

/* form */
import Input from "../../../shared/components/form/input"
import FormLayout from "../../../shared/components/FormLayout/FormLayout"
import FormSection from "../../../shared/components/FormLayout/FormSection"
import Button from "../../../shared/components/Button/Button"
import Modal from "../../../shared/modal/Modal"
import FormSize from "./FormSize"
import NumberToMoney from '../../../shared/functions/NumberToMoney'
import './FormSizeGrid.css'

function FormSizeGrid({ handleSubmit, sizeGridData, gridData, btnText, btCancelLink, btCancelAction, title }) {

    const [sizeGrid, setSizeGrid] = useState(sizeGridData || {})
    const [grid, setGrid] = useState(gridData || [])
    const [modalFormSize, setModalFormSize] = useState(false)
    const [modalSizeEdit, setModalSizeEdit] = useState(false)
    const [editSizeData, setEditSizeData] = useState({})
    const [dragIndex, setDragIndex] = useState(null)
    const [dragOverIndex, setDragOverIndex] = useState(null)

    function handleChange(e) {
        setSizeGrid({ ...sizeGrid, [e.target.name]: e.target.value })
    }

    function submit(e) {
        e.preventDefault()
        // Evita que o submit borbulhe (via árvore React, mesmo com o Modal via portal) e
        // acione também o onSubmit do formulário que abriu este como "cadastro rápido".
        e.stopPropagation()

        let data = sizeGrid
        data = {...sizeGrid, grid: grid}
        handleSubmit(data)
    }

    const addSize = (data) => {
        let id = Date.now();
        data = { ...data, _id: id }
        setGrid([...grid, data])
        setModalFormSize(false)
    }
    const editSize = (item) => {
        setModalSizeEdit(true)
        setEditSizeData(item)
    }
    const updateEditSize = (i) => {
         let data = grid.map((item) => {
            if (i._id === item._id) {
                return { _id: i._id, name: i.name, price: i.price }
            } else {
                return item
            }
        }
        )
        setGrid(data)
        setModalSizeEdit(false)
    }
    const removeSize = (id) => {
        const updatedArray = grid.filter((item) => {
            return item._id !== id
        })
        setGrid(updatedArray)
    }

    /* ------------------- Reordenar por arrastar ----------------------*/
    const handleDragStart = (index) => setDragIndex(index)
    const handleDragOver = (e, index) => {
        e.preventDefault()
        if (index !== dragOverIndex) setDragOverIndex(index)
    }
    const handleDrop = (index) => {
        if (dragIndex === null || dragIndex === index) {
            setDragIndex(null)
            setDragOverIndex(null)
            return
        }
        const updatedArray = [...grid]
        const [moved] = updatedArray.splice(dragIndex, 1)
        updatedArray.splice(index, 0, moved)
        setGrid(updatedArray)
        setDragIndex(null)
        setDragOverIndex(null)
    }
    const handleDragEnd = () => {
        setDragIndex(null)
        setDragOverIndex(null)
    }

    return (
        <>
            <FormLayout
                title={title}
                onSubmit={submit}
                actions={
                    <>
                        <Button variant="save" type="submit">{btnText || 'Salvar'}</Button>
                        {btCancelLink
                            ? <Link className="link-default" to={btCancelLink}><Button variant="cancel">Cancelar</Button></Link>
                            : btCancelAction && <Button variant="cancel" onClick={btCancelAction}>Cancelar</Button>
                        }
                    </>
                }
            >
                <FormSection label="Identificação">
                    <div className="fl-row">
                        <div className="fl-col-wide form-group">
                            <Input
                                text="Nome da grade"
                                type="text"
                                name="name"
                                placeholder="digite o nome da grade"
                                handleOnChange={handleChange}
                                value={sizeGrid.name || ''}
                            />
                        </div>
                    </div>
                </FormSection>

                <FormSection label="Tamanhos">
                    <div className="fl-row">
                        <Button variant="new" type="button" onClick={() => { setModalFormSize(true) }}>Adicionar</Button>
                    </div>

                    {grid.length > 0 ? (
                        <>
                            <p className="sizegrid-chip-hint">Arraste pelo <FaGripVertical size={10} /> para reordenar</p>
                            <div className="sizegrid-chip-list">
                                {grid.map((i, index) => (
                                    <div
                                        key={i._id}
                                        className={`sizegrid-chip ${dragIndex === index ? 'sizegrid-chip-dragging' : ''} ${dragOverIndex === index && dragIndex !== null && dragIndex !== index ? 'sizegrid-chip-drop-target' : ''}`}
                                        draggable
                                        onDragStart={() => handleDragStart(index)}
                                        onDragOver={(e) => handleDragOver(e, index)}
                                        onDrop={() => handleDrop(index)}
                                        onDragEnd={handleDragEnd}
                                    >
                                        <FaGripVertical className='sizegrid-chip-handle' title='Arrastar para reordenar' />
                                        <span className='sizegrid-chip-name'>{i.name}</span>
                                        <span className='sizegrid-chip-price'>R$ {NumberToMoney(i.price)}</span>
                                        <div className='sizegrid-chip-actions'>
                                            <FaPencilAlt className='shd-icon-row-edit' title='Editar' onClick={() => { editSize(i) }} />
                                            <FaTrashAlt className='shd-icon-row-trash' title='Apagar' onClick={() => { removeSize(i._id) }} />
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </>
                    ) : (
                        <p className="sizegrid-chip-empty">Nenhum tamanho adicionado ainda.</p>
                    )}
                </FormSection>
            </FormLayout>

            <Modal
                modalStatus={modalFormSize}
                changeStatus={setModalFormSize}
                w={40}
                content={
                    <FormSize title="Adicionar Tamanho" btnText={"Adicionar"} btCancelAction={() => setModalFormSize(false)} handleSubmit={addSize} />
                }
            />
            <Modal
                modalStatus={modalSizeEdit}
                changeStatus={setModalSizeEdit}
                w={40}
                content={
                    <FormSize title="Editar Tamanho" btnText={"Salvar"} btCancelAction={() =>  setModalSizeEdit(false)} sizeData={editSizeData} handleSubmit={updateEditSize} />
                }
            />
        </>
    )
}

export default FormSizeGrid
